import * as React from "react"
const IconArrows = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 39.99 39.99"
        width={width}
        height={height}
    >
        <path d="m39.99 0-20 19.99L0 0" style={{fill: "#99835d"}}/>
        <path d="M39.99 19.99H0l19.99 20 20-20z" style={{fill: "#eae0d8"}}/>
    </svg>
)
export default IconArrows
